module.exports = __webpack_public_path__ + "aab920e04211577da140c01f1f39adff.woff";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = 400
// module chunks = 0